
/* eslint-disable */
import { initObjectHash } from './common/objectHash';
import { initIsMobile } from './common/isMobile';
initObjectHash();
initIsMobile();

// @TODO - need to rewrite this file - legacy code from 2017

export function initPersistentIdentifier() {


    // Global Querystring Parser V1.1
    //inserting my common stuff
    var requiredData = ['aff_id', 'sub_id', 'req_id', 'user_id'];
    var global_key_prefix = 'giddy-';
    var checkout_token_name = 'tkn';
    var localData = Object.create(null);


    //NOTE: it was expressed to not use global_key_prefix for url params.
    var localToURLNameKeys = {
        user_id: 'guu'
    };


    function copyDataTo_gu_qs(gu_qs, data) {
        for (var i = 0; i < requiredData.length; i++) {
            var key = requiredData[i];
            var qsKey = (localToURLNameKeys[key] ? localToURLNameKeys[key] : key);
            //NOTE: dont override what is already in gu_qs. and dont add undefined
            if ((!gu_qs[qsKey] || gu_qs[qsKey] == 'undefined') && data[key]) {
                gu_qs[qsKey] = data[key];
            }
            //NOTE: user_id from other sources wins.  if user_id is undefined then bug somewhere
            if (key === 'user_id' && data[key]) {
                gu_qs[qsKey] = data[key];
            }
        }
    }
    window['copyDataTo_gu_qs'] = copyDataTo_gu_qs;

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
            return this.substr(position || 0, searchString.length) === searchString;
        };
    }

    function gu_assign(dest, source) {
        for (var k in source) {
            if (k && source[k] && source[k] != 'undefined') {
                dest[k] = source[k];
            }
        }
        return dest;
    }


    function getDomain() {
        var parts = document.location.hostname.toLowerCase().split('.');
        var domain = parts.slice(-2).join('.');

        return domain;
    }
    window['getDomain'] = getDomain;

    //copied from mdn
    var docCookies = {
        getItem: function (sKey) {
            if (!sKey) {
                return null;
            }
            return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
        },
        setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
            if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
                return false;
            }

            if (!vEnd) {
                vEnd = Infinity;
            }

            var sExpires = '';
            if (vEnd) {
                switch (vEnd.constructor) {
                    case Number:
                        sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
                        break;
                    case String:
                        sExpires = '; expires=' + vEnd;
                        break;
                    case Date:
                        sExpires = '; expires=' + vEnd.toUTCString();
                        break;
                }
            }
            document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
            return true;
        },
        removeItem: function (sKey, sPath, sDomain) {
            if (!this.hasItem(sKey)) {
                return false;
            }
            document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '');
            return true;
        },
        hasItem: function (sKey) {
            if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
                return false;
            }
            return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
        },
        keys: function () {
            var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
            for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
                aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
            }
            return aKeys;
        }
    };

    function getCookieData() {
        //NOTE: try catch prevents optimization but not going to have an effect
        var hld = Object.create(null);
        try {
            var cData = docCookies.keys();

            for (var i = 0; i < cData.length; i++) {
                if (cData[i].startsWith(global_key_prefix)) {
                    //NOTE: we know its our data and not wild stuff in shoppify.com
                    hld[cData[i].replace(global_key_prefix, '')] = docCookies.getItem(cData[i]);
                }
            }
            return hld;
        } catch (e) {
            return hld;
        }
    }

    function getLocalStorageData() {
        var hldItms = Object.create(null);
        try {
            if (typeof (Storage) !== 'undefined') {
                for (var i = 0; i < localStorage.length; i++) {
                    var cKey = localStorage.key(i);
                    if (cKey.startsWith(global_key_prefix)) {
                        //NOTE: we know its our data and not wild stuff in shoppify.com  
                        hldItms[cKey.replace(global_key_prefix, '')] = localStorage.getItem(cKey);
                    }
                }
            }
        } catch (e) { } finally {
            return hldItms;
        }
    }

    function getLocalData() {
        var cData = getCookieData();

        var sData = getLocalStorageData();

        return gu_assign(sData, cData);
    }

    function saveDataLocal(data) {
        //NOTE: assumes data already merged with priority
        //NOTE: tmp for now may make array of excluded props
        delete data.referrer;
        var oKeys = Object.keys(data);
        for (var i = 0; i < oKeys.length; i++) {
            try {
                var key = oKeys[i];
                if (key && typeof (data[key]) !== 'undefined' && data[key] !== 'undefined') {
                    //save to cookie
                    //docCookies.setItem(global_key_prefix + key, data[key]);
                    //save to local storage
                    if (typeof (Storage) !== 'undefined') {
                        localStorage[global_key_prefix + key] = data[key];
                    }
                }
            } catch (e) {
                var huh = true;
            }
        }
    }

    function getCheckoutTokenFromURL() {
        try {
            var parts = document.location.pathname.split('/');

            for (var i = 0; i < parts.length; i++) {
                if (parts[i].toLowerCase() == 'checkouts') {
                    return parts[i + 1];
                }
            }
        } catch (e) {

        }
        return null;
    }



    //uuid v4
    ! function (n) {
        if ('object' == typeof exports && 'undefined' != typeof module) module.exports = n();
        else if ('function' == typeof define && define.amd) define([], n);
        else {
            var e;
            e = 'undefined' != typeof window ? window : 'undefined' != typeof global ? global : 'undefined' != typeof self ? self : this, e.uuidv4 = n()
        }
    }(function () {
        return function n(e, r, o) {
            function t(f, u) {
                if (!r[f]) {
                    if (!e[f]) {
                        var a = 'function' == typeof require && require;
                        if (!u && a) return a(f, !0);
                        if (i) return i(f, !0);
                        var d = new Error('Cannot find module \'' + f + '\'');
                        throw d.code = 'MODULE_NOT_FOUND', d
                    }
                    var l = r[f] = {
                        exports: {}
                    };
                    e[f][0].call(l.exports, function (n) {
                        var r = e[f][1][n];
                        return t(r ? r : n)
                    }, l, l.exports, n, e, r, o)
                }
                return r[f].exports
            }
            for (var i = 'function' == typeof require && require, f = 0; f < o.length; f++) t(o[f]);
            return t
        }({
            1: [function (n, e, r) {
                function o(n, e) {
                    var r = e || 0,
                        o = t;
                    return o[n[r++]] + o[n[r++]] + o[n[r++]] + o[n[r++]] + '-' + o[n[r++]] + o[n[r++]] + '-' + o[n[r++]] + o[n[r++]] + '-' + o[n[r++]] + o[n[r++]] + '-' + o[n[r++]] + o[n[r++]] + o[n[r++]] + o[n[r++]] + o[n[r++]] + o[n[r++]]
                }
                for (var t = [], i = 0; i < 256; ++i) t[i] = (i + 256).toString(16).substr(1);
                e.exports = o
            }, {}],
            2: [function (n, e, r) {
                (function (n) {
                    var r, o = n.crypto || n.msCrypto;
                    if (o && o.getRandomValues) {
                        var t = new Uint8Array(16);
                        r = function () {
                            return o.getRandomValues(t), t
                        }
                    }
                    if (!r) {
                        var i = new Array(16);
                        r = function () {
                            for (var n, e = 0; e < 16; e++) 0 === (3 & e) && (n = 4294967296 * Math.random()), i[e] = n >>> ((3 & e) << 3) & 255;
                            return i
                        }
                    }
                    e.exports = r
                }).call(this, 'undefined' != typeof global ? global : 'undefined' != typeof self ? self : 'undefined' != typeof window ? window : {})
            }, {}],
            3: [function (n, e, r) {
                function o(n, e, r) {
                    var o = e && r || 0;
                    'string' == typeof n && (e = 'binary' == n ? new Array(16) : null, n = null), n = n || {};
                    var f = n.random || (n.rng || t)();
                    if (f[6] = 15 & f[6] | 64, f[8] = 63 & f[8] | 128, e)
                        for (var u = 0; u < 16; ++u) e[o + u] = f[u];
                    return e || i(f)
                }
                var t = n('./lib/rng'),
                    i = n('./lib/bytesToUuid');
                e.exports = o
            }, {
                './lib/bytesToUuid': 1,
                './lib/rng': 2
            }]
        }, {}, [3])(3)
    });


    // Convert a name/value querystring array to string version
    function gu_qs_to_str(qs) {
        var e = encodeURIComponent;
        var s = '';
        for (var k in qs) {
            if (s != '') {
                s += '&';
            }
            s += e(k) + '=' + e(qs[k]);
        }
        if (s != '') {
            s = '?' + s;
        }
        return s;
    }
    window['gu_qs_to_str'] = gu_qs_to_str;

    // Parse a query string into key/value pairs
    function gu_deparam(querystring) {
        var params = [];
        if (querystring == '' || querystring == '?') {
            return params;
        }
        if (querystring[0] == '?') {
            querystring = querystring.substr(1);
        }
        querystring = querystring.split('&');
        var params = {},
            pair, d = decodeURIComponent;
        for (var i = querystring.length - 1; i >= 0; i--) {
            pair = querystring[i].split('=');
            params[d(pair[0])] = d(pair[1]);
        }
        return params;
    } //--  fn  gu_deparam
    window['gu_deparam'] = gu_deparam;

    // Create global query string key/value pair array
    window['gu_qs'] = gu_deparam(document.location.search);
    localData = getLocalData();
    copyDataTo_gu_qs(window['gu_qs'], localData);



    // RequestIdPersistance Callback BL V1.1
    var dataFlush = false;

    // function RequestIdPersistanceCallbackBL(response) {
    //     try {
    //         if (!dataFlush) {
    //             var tmp_gu_qs = gu_deparam(document.location.search);
    //             if (response.converted) {
    //                 dataFlush = true;
    //                 var hldFp = localData.fp;
    //                 var hldUser_id = localData.user_id;
    //                 var oKeys = Object.keys(localData);
    //                 for (var i = 0; i < oKeys.length; i++) {
    //                     localData[oKeys[i]] = null
    //                 }
    //                 localData.flushed = true;
    //                 localData.fp = hldFp;
    //                 localData.user_id = hldUser_id;
    //                 localData.search = document.location.search;
    //                 if (response.user_id && response.user_id.length >= 36) {
    //                     localData.user_id = response.user_id
    //                 }
    //                 if (tmp_gu_qs['req_id'] && localData['req_id'] !== tmp_gu_qs['req_id']) {
    //                     localData['req_id'] = null;
    //                     localData['sub_id'] = null;
    //                     localData['aff_id'] = null
    //                 }
    //                 gu_assign(localData, tmp_gu_qs);
    //                 saveDataLocal(localData);
    //                 if (tmp_gu_qs.guu) {
    //                     localData.user_id = tmp_gu_qs.guu
    //                 } else {
    //                     tmp_gu_qs.guu = localData.user_id
    //                 }
    //                 gu_qs = tmp_gu_qs
    //             } else {
    //                 if (response['req_id']) {
    //                     if (localData['req_id'] && response['req_id'] != localData['req_id']) { } else {
    //                         for (var i = 0; i < requiredData.length; i++) {
    //                             var key = requiredData[i];
    //                             if (!localData[key] || localData[key] == 'undefined' && response[key]) {
    //                                 localData[key] = response[key]
    //                             }
    //                         }
    //                     }
    //                 }
    //                 if (response.user_id && response.user_id.length >= 36 && response['guu_ttl'] && response['guu_ttl'] * 1000 > Date.now()) {
    //                     localData.user_id = response.user_id;
    //                     window['gu_qs']['guu'] = localData['user_id']
    //                 }
    //                 if (response.search) {
    //                     var tmp = gu_deparam(response.search);
    //                     gu_assign(tmp, window['gu_qs']);
    //                     gu_assign(window['gu_qs'], tmp)
    //                 }
    //                 gu_assign(localData, window['gu_qs']);
    //                 copyDataTo_gu_qs(window['gu_qs'], localData);
    //                 localData.search = gu_qs_to_str(window['gu_qs']);
    //                 saveDataLocal(localData)
    //             }
    //             if (typeof gu_linkfix !== 'undefined' && gu_linkfix) {
    //                 gu_linkfix()
    //             }
    //             if (dataFlush) {
    //                 giddySubmit(dataFlush)
    //             }
    //         } else {
    //             dataFlush = !dataFlush
    //         }
    //         window.guPersisted = true;
    //     } catch (e) {
    //         window.guPersisted = true;
    //     }
    // }


    // RequestId Persistance V1.0

    // This code was taken from 1.6 build - could not find unminified version and needs to be fixed.
    // function giddySubmit(e) {
    //     var t = {
    //         baseUrl: 'https://hxxzpf30e2.execute-api.us-east-1.amazonaws.com/prod',
    //         key: 'JZJ0JNFzlq792ur4K5G9h55iyE7QbEA19nqpK5Jt'
    //     };
    //     var n = [t];
    //     var r = -1;
    //     var o = -1;

    //     function i() {
    //         ++o;
    //         return 1e3 * Math.pow(2, o) + Math.random() * 100
    //     }

    //     function a() {
    //         var e = Object.create(null);

    //         function t() {
    //             return window.navigator.language
    //         }

    //         function n() {
    //             return window.screen.colorDepth
    //         }

    //         function r() {
    //             return window.devicePixelRatio
    //         }

    //         function o() {
    //             return window.screen.pixelDepth
    //         }

    //         function i() {
    //             var e = 1;
    //             try {
    //                 e = window.screen.height * window.screen.width
    //             } catch (e) { }
    //             return e
    //         }

    //         function a() {
    //             var e = 1;
    //             try {
    //                 e = window.screen.deviceXDPI * window.screen.deviceYDPI
    //             } catch (e) { }
    //             return e
    //         }

    //         function u() {
    //             try {
    //                 return !!window.sessionStorage
    //             } catch (e) {
    //                 return true
    //             }
    //         }

    //         function s() {
    //             try {
    //                 return !!window.localStorage
    //             } catch (e) {
    //                 return true
    //             }
    //         }

    //         function f() {
    //             try {
    //                 return !!window.indexedDB
    //             } catch (e) {
    //                 return true
    //             }
    //         }

    //         function c() {
    //             if (window.openDatabase) {
    //                 return true
    //             }
    //             return true
    //         }

    //         function l() {
    //             if (window.navigator.cpuClass) {
    //                 return window.navigator.cpuClass
    //             } else {
    //                 return 'unknown'
    //             }
    //         }

    //         function d() {
    //             if (window.navigator.platform) {
    //                 return window.navigator.platform
    //             } else {
    //                 return 'unknown'
    //             }
    //         }

    //         function h() {
    //             var e = window.navigator;
    //             var t = 0;
    //             var n = false;
    //             if (typeof e.maxTouchPoints !== 'undefined') {
    //                 t = e.maxTouchPoints
    //             } else if (typeof e.msMaxTouchPoints !== 'undefined') {
    //                 t = e.msMaxTouchPoints
    //             }
    //             try {
    //                 document.createEvent('TouchEvent');
    //                 n = true
    //             } catch (e) { }
    //             var r = 'ontouchstart' in window;
    //             return [t, n, r].join(',')
    //         }

    //         function p() {
    //             return window.navigator.hardwareConcurrency
    //         }

    //         function g() {
    //             try {
    //                 var e = document.createElement('canvas');
    //                 return !!(e.getContext && e.getContext('2d'))
    //             } catch (e) {
    //                 return false
    //             }
    //         }

    //         function y() {
    //             if (!g()) {
    //                 return false
    //             }
    //             var e = document.createElement('canvas');
    //             var t;
    //             try {
    //                 t = e.getContext && (e.getContext('webgl') || e.getContext('experimental-webgl'))
    //             } catch (e) {
    //                 t = false
    //             }
    //             return !!window.WebGLRenderingContext && !!t
    //         }

    //         function w() {
    //             return window.navigator.oscpu
    //         }
    //         e['userLanguage'] = t();
    //         e['colorDepth'] = n();
    //         e['pixelRatio'] = r();
    //         e['getPixelDepth'] = o();
    //         e['getScreenResolutionNumber'] = i();
    //         e['getDPINumber'] = a();
    //         e['hasSessionStorage'] = u();
    //         e['hasLocalStorage'] = s();
    //         e['hasIndexedDB'] = f();
    //         e['hasopenDatabase'] = c();
    //         e['getNavigatorCpuClass'] = l();
    //         e['getNavigatorPlatform'] = d();
    //         e['getTouchSupport'] = h();
    //         e['getHardwareConcurrency'] = p();
    //         e['isCanvasSupported'] = g();
    //         e['isWebGlSupported'] = y();
    //         e['getOSVersion'] = w();
    //         return window.objectHash.sha1(e)
    //     }

    //     function u(e) {
    //         var t = document.referrer;
    //         if (!t) {
    //             t = 'none'
    //         }
    //         var o = n[r].baseUrl + '/' + encodeURIComponent(e.fp) + '/' + encodeURIComponent(e.user_id) + '/' + encodeURIComponent(e.domain) + '/' + encodeURIComponent(e.req_id) + '/' + encodeURIComponent(e.sub_id) + '/' + encodeURIComponent(e.aff_id) + '/' + encodeURIComponent(t) + '/' + encodeURIComponent(e.tkn ? e.tkn : 'none');
    //         return o
    //     }

    //     function s(t) {
    //         ++r;
    //         if (r >= n.length) {
    //             r = 0
    //         }
    //         var o = new XMLHttpRequest;
    //         o.open('GET', u(t), true);
    //         o.setRequestHeader('x-api-key', n[r].key);
    //         o.responseType = 'json';
    //         o.withCredentials = true;
    //         o.setRequestHeader('hostname', document.location.hostname);
    //         o.setRequestHeader('lp_domain', getDomain());
    //         o.setRequestHeader('page', document.location.pathname);
    //         o.setRequestHeader('search', encodeURIComponent(document.location.search));
    //         o.setRequestHeader('guu_ttl', localData['guu_ttl']);
    //         if (e) {
    //             o.setRequestHeader('dataFlush', true)
    //         }
    //         if (document.location.href.indexOf('req_id') >= 0 && gu_qs['req_id'] !== 'undefined') {
    //             o.setRequestHeader('lp_url', document.location.href)
    //         }
    //         o.setRequestHeader('mobileDevice', mobileDevice);
    //         o.onreadystatechange = function () {
    //             if (o.readyState == 4) {
    //                 if (o.status == 200) {
    //                     if (o.response) {
    //                         RequestIdPersistanceCallbackBL(o.response)
    //                     }
    //                 } else {
    //                     setTimeout(s, i(), t)
    //                 }
    //             }
    //         };
    //         o.send(null)
    //     }
    //     localData = getLocalData();
    //     if (!localData['fp']) {
    //         localData['fp'] = a()
    //     }
    //     var f = getCheckoutTokenFromURL();
    //     if (f) {
    //         localData[checkout_token_name] = f
    //     }
    //     localData.domain = getDomain();
    //     localData.lp_domain = getDomain();
    //     localData.page = document.location.pathname;
    //     if (localData.search) {
    //         var c = gu_deparam(localData.search);
    //         Object.assign(c, gu_qs);
    //         Object.assign(gu_qs, c)
    //     } else {
    //         localData.search = document.location.search
    //     }
    //     Object.assign(localData, gu_qs);
    //     copyDataTo_gu_qs(gu_qs, localData);
    //     if (localData['guu_ttl'] && localData['guu_ttl'] > Date.now() && localData['user_id'] && localData['user_id'].length >= 36 && localData['fp'].length > 32 && localData['fp'].length < 45 && localData['fp'] !== localData['user_id']) { } else {
    //         localData['user_id'] = uuidv4();
    //         localData['guu_ttl'] = Date.now() + 31 * 24 * 60 * 60 * 1e3;
    //         localData['fp'] = a();
    //         gu_qs['guu'] = localData['user_id']
    //     }
    //     localData.search = gu_qs_to_str(gu_qs);
    //     saveDataLocal(localData);
    //     s(localData)
    // }
    giddySubmit();
}

/* eslint-enable */
